import { apiInstance } from '../apiInstance';
import { ApiRoutes } from '../apiRoutes';

export const resendActivationEmail = async (email: string) => {
  return apiInstance.post(ApiRoutes.ResendActivation, { email });
};
